import { ReactNode } from "react";
import styles from "./Pill.module.css";

interface PillProps {
  tone?: "neutral" | "amber" | "indigo" | "success" | "glass";
  icon?: ReactNode;
  children: ReactNode;
}

export default function Pill({ tone = "neutral", icon, children }: PillProps) {
  return (
    <span className={`${styles.pill} ${styles[tone]}`}>
      {icon}
      {children}
    </span>
  );
}
